import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Vinted = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <rect x="2" y="2" width="16" height="16" rx="3" fill="#007782" />
      <path
        d="M13.8336 3.71183C13.6983 3.71183 13.5342 3.82571 13.0919 4.211C12.9349 4.26794 12.7636 4.22524 12.5638 4.53224C11.4369 6.1517 10.5595 12.2077 9.81029 13.9558C9.66035 13.1994 9.34671 8.27698 9.22524 6.92893C9.211 6.67934 9.23947 6.36522 9.23947 6.18017C9.23947 4.93888 8.96901 4.31065 7.72725 4.31065C7.09948 4.31065 6.47932 4.53935 6.15096 4.95312C5.99438 5.16664 5.93696 5.32417 5.93696 5.70899C5.93696 8.28457 6.55049 12.5071 7.23519 15.2606C7.44919 16.1242 8.21977 16.2879 8.94718 16.2879C9.28977 16.2879 9.63188 16.2452 10.1173 16.0028C11.8003 15.1819 12.2502 12.9422 12.6853 10.7667C12.7636 10.3743 13.156 8.47674 13.3415 7.4784C13.5911 6.11564 13.8763 4.57494 14.0476 4.01124C14.1045 3.84042 13.9973 3.71183 13.8336 3.71183Z"
        fill="white"
      />
    </svg>
  )
})

export default Vinted
